import
React
  from 'react';

import {
  connect
} from 'react-redux';

import
classnames
  from 'classnames';

import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  UncontrolledTooltip,
} from 'reactstrap';

import {
  OrdenExpressNavegatePath
} from 'orden_express/frameWork/frameWork'

class AdminNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      color: window.innerWidth < 993 ? 'bg-white' : 'navbar-transparent'
    };
    this.handlerClickMenuInBarNav = this.handlerClickMenuInBarNav.bind(this);
  }

  componentDidUpdate(e) {
    if (
      window.outerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf('nav-open') !== -1
    ) {
      document.documentElement.classList.toggle('nav-open');
      window.addEventListener('resize', this.updateColor);
    }

  }
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor = () => {
    if (window.innerWidth < 993 && this.state.collapseOpen) {
      this.setState({
        color: 'bg-white'
      });
    } else {
      this.setState({
        color: 'navbar-transparent'
      });
    }
  };
  // this function opens and closes the sidebar on small devices
  toggleSidebar = () => {
    document.documentElement.classList.toggle('nav-open');
  };
  // this function opens and closes the collapse on small devices
  // it also adds navbar-transparent class to the navbar when closed
  // ad bg-white when opened
  toggleCollapse = () => {
    let newState = {
      collapseOpen: !this.state.collapseOpen
    };
    if (!this.state.collapseOpen) {
      newState['color'] = 'bg-white';
    } else {
      newState['color'] = 'navbar-transparent';
    }
    this.setState(newState);
  };

  renderMenuExit = () => {
    return (
      <NavItem key={'NavItem-salir'}>
        <NavLink
          id={'NavItem-salir-id'}
          className='btn-magnify'
          //href='javascript:void(0);'
          onClick={(even) => {
            this.toggleCollapse();
            this.updateColor();
            this.props.callbackGetOut()
            even.preventDefault();
          }
          }
        >
          <i className={'nc-icon nc-button-power'} />
          <p>
            <span className='d-lg-none d-md-block'>
              {'Salir'}
            </span>
          </p>
          <UncontrolledTooltip
            delay={0}
            target={'NavItem-salir-id'}
          >
            {'Salir'}
          </UncontrolledTooltip>
        </NavLink>
      </NavItem>
    );
  }

  handlerClickMenuInBarNav = (e, localroute) => {
    OrdenExpressNavegatePath(this, localroute.path.replace('/', ''));
    this.toggleCollapse();
    this.updateColor();
    e.preventDefault();
  }

  renderContentForMenuIBarNav = (key, pLastValue, localroute) => {
    return (
      <NavItem key={`${key}-${pLastValue}`}>
        <NavLink
          id={`NavLink-${key}-${pLastValue}`}
          className='btn-magnify'
          onClick={e => this.handlerClickMenuInBarNav(e, localroute)}
        >
          <i className={localroute.icon} />
          <p>
            <span className='d-lg-none d-md-block'>
              {localroute.name}
            </span>
          </p>
          <UncontrolledTooltip
            delay={0}
            target={`NavLink-${key}-${pLastValue}`}
          >
            {localroute.name}
          </UncontrolledTooltip>
        </NavLink>
      </NavItem>
    )
  }

  renderMenuInBarNav = (pRoutes, pLastValue = 0) => {
    var result = [];
    var pos = 0;
    var length = pRoutes.length;
    while (pos < length) {
      var localroute = pRoutes[pos];
      var key = pos;
      if (localroute.collapse) {
        result = result.concat(this.renderMenuInBarNav(localroute.views, key));
      } else {
        if (!localroute.hide) {
          result.push(
            this.renderContentForMenuIBarNav(key, pLastValue, localroute)
          );
        }
      }
      pos++;
    }
    /*    pRoutes.map((localroute, key) => {
          if (localroute.collapse) {
            result = result.concat(this.renderMenuInBarNav(localroute.views, key));
          } else {
            if (!localroute.hide) {
              result.push(
                <NavItem key={`${key}-${pLastValue}`}>
                  <NavLink
                    id={`NavLink-${key}-${pLastValue}`}
                    className='btn-magnify'
                    href=''
                    onClick={e => {
                      OrdenExpressNavegatePath(this, localroute.path.replace('/', ''));
                      this.toggleCollapse();
                      this.updateColor();
                      e.preventDefault();
                    }
                    }
                  >
                    <i className={localroute.icon} />
                    <p>
                      <span className='d-lg-none d-md-block'>
                        {localroute.name}
                      </span>
                    </p>
                    <UncontrolledTooltip
                      delay={0}
                      target={`NavLink-${key}-${pLastValue}`}
                    >
                      {localroute.name}
                    </UncontrolledTooltip>
                  </NavLink>
                </NavItem>
              );
            }
          }
        });*/
    return result;
  }

  render() {
    return (
      <Navbar
        className={classnames('navbar-absolute fixed-top', this.state.color) + ' mt-0 mb-0'}
        expand='lg'
      >
        <Container fluid>
          <div className='navbar-wrapper'>
            <div className='navbar-minimize'>
              <Button
                className='btn-icon btn-round'
                color='default'
                id='minimizeSidebar'
                onClick={this.props.handleMiniClick}
              >
                <i className='nc-icon nc-minimal-right text-center visible-on-sidebar-mini' />
                <i className='nc-icon nc-minimal-left text-center visible-on-sidebar-regular' />
              </Button>
            </div>
            <div
              className={classnames('navbar-toggle', {
                toggled: this.state.sidebarOpen
              })}
            >
              <button
                className='navbar-toggler'
                type='button'
                onClick={this.toggleSidebar}
              >
                <span className='navbar-toggler-bar bar1' />
                <span className='navbar-toggler-bar bar2' />
                <span className='navbar-toggler-bar bar3' />
              </button>
            </div>
            <NavbarBrand href='#_' onClick={e => e.preventDefault()}>
              <span className='d-none d-md-block'>
                {'Orden Express'}
              </span>
              <span className='d-block d-md-none'>Orden express</span>
            </NavbarBrand>
          </div>
          <button
            aria-controls='navigation-index'
            aria-expanded={this.state.collapseOpen}
            aria-label='Toggle navigation'
            className='navbar-toggler'
            // data-target='#navigation'
            data-toggle='collapse'
            type='button'
            onClick={this.toggleCollapse}
          >
            <span className='navbar-toggler-bar navbar-kebab' />
            <span className='navbar-toggler-bar navbar-kebab' />
            <span className='navbar-toggler-bar navbar-kebab' />
          </button>
          <Collapse
            className='justify-content-end'
            navbar
            isOpen={this.state.collapseOpen}>
            <Nav navbar>
              {this.renderMenuInBarNav(this.props.routes)}
              {this.renderMenuExit()}
            </Nav>
            {/*this.renderMenuInBarNav(this.props.routes)*/}
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

const mapStateToProps = state => {
  return {
    loginReducerState: state.loginReducerState,
  };
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminNavbar);